import { AuthenticationError } from '~/errors/AuthenticationError';
import { Navigate, useRouteError } from 'react-router';
import { isAxiosError } from 'axios';

function isAuthenticationError(error: unknown) {
  return error instanceof AuthenticationError || (isAxiosError(error) && error.status === 401);
}

export function Page() {
  const error = useRouteError();

  if (isAuthenticationError(error)) {
    return <Navigate to="/auth/sign-in" />;
  }

  return false;
}
